// removed by extract-text-webpack-plugin
module.exports = {"MessageContainer":"Message__MessageContainer__b6ZTP","Message":"Message__Message__39SVI"};